var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landBase"},[_c('AppHeader',{attrs:{"isShowTitle":true}}),_c('nuxt'),(_vm.isExternalSiteModalShown)?_c('external-site-modal',{attrs:{"title":_vm.externalSite.title,"url":_vm.externalSite.url,"internalLink":_vm.externalSite.internalLink},on:{"modal-close":function($event){return _vm.setExternalSite({})}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }